import { DispachedServicePart, Service } from '@services';
import { IServiceBasket } from '@stores';
import React from 'react';

/** Props shared by all ServiceDetailsCard presentation variants */
export interface IServiceDetailsPresentation {
  service: Service;
  disabled: boolean;
  vat: number;
  subTotal: number;
  vatAmount: number;
  total: number;
  parts: DispachedServicePart[];
  onAddPart: () => void;
  onRemovePart: (index: number) => void;
  onUpdatePart: (index: number, values: Partial<DispachedServicePart>) => void;
  onAddPartToPurchaseOrder?: (index: number) => void;
  handlePriceUpdate: (id: number, price: number) => void;
  handleDurationUpdate: (id: number, duration: number) => void;
  handleDiscountUpdate: (id: number, discount: number) => void;
  handleNoteUpdate: (id: number, note: string) => void;
  /** Takes this service off the job. Absent = not removable here (e.g. the revision view). */
  onRemove?: () => void;
  /** False when this is the last service and the job must keep one. */
  canRemove?: boolean;
}

/** External props passed to the container */
export interface IServiceDetailsCardProps {
  service: Service;
  disabled?: boolean;
  variant?: 'selected' | 'additional' | 'revision';
  /**
   * Edits this basket instead of serviceStore's own. Passed down by OrderServiceSelect when the
   * booking drawer is building several unsaved jobs at once; omitted everywhere else.
   */
  basket?: IServiceBasket;
  onRemove?: () => void;
  canRemove?: boolean;
}

/** Shared styles used by presentation variants */
export const headerRowStyle: React.CSSProperties = {
  background: 'linear-gradient(90deg, #f0f7ff 0%, #fafafa 100%)',
  borderRadius: 6,
  padding: '6px 0',
  marginBottom: 8,
};

export const headerLabelStyle: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  color: '#8c8c8c',
  textTransform: 'uppercase',
  letterSpacing: 0.3,
};

export const dataRowStyle: React.CSSProperties = {
  padding: '4px 0',
  alignItems: 'center',
};

export const totalCellStyle: React.CSSProperties = {
  fontSize: 14,
  fontWeight: 700,
  color: '#1a3353',
  background: '#e8f4fd',
  padding: '2px 8px',
  borderRadius: 4,
  display: 'inline-block',
};

export const subtotalCellStyle: React.CSSProperties = {
  fontSize: 13,
  color: 'rgba(0, 0, 0, 0.65)',
};
